module.exports = __webpack_public_path__ + "static/media/samudera_logo.48d5c205.png";